// rg-reviews-toggle: Judge.me (cards_carousel) no tiene una opcion nativa
// para "mostrar 6 y desplegar el resto" -- esto lo hace a mano.
//
// Verificado con navegador headless (2026-09-08) que Judge.me puede
// RECONSTRUIR el carrusel completo mas de una vez despues de la carga
// inicial (por ejemplo al recalcular tamaños), reemplazando el nodo
// .jdgm-videos-container por uno nuevo y borrando cualquier cambio manual
// hecho sobre el anterior. Por eso este script NO aplica el "mostrar 6" una
// sola vez: reacciona a cada reconstruccion y lo vuelve a aplicar (es
// idempotente -- no pasa nada si se aplica varias veces sobre el mismo
// estado ya correcto).
(function () {
  var VISIBLE_COUNT = 6;
  var DEBOUNCE = 400;
  var SELECTOR = '.jdgm-cards-carousel .jdgm-videos-container';

  // rg (2026-10-01): se saca el toggle de "reseñas escritas completas"
  // (".jdgm-rev-widg") agregado el 2026-09-30 -- verificado via curl con
  // cookie de preview (draft 3) que ese widget NO ESTA INSTALADO en ningun
  // lado del sitio (ni product.json ni index.json tienen un block
  // "shopify://apps/judge-me-reviews/blocks/..." de listado completo, solo
  // "preview_badge" y "cards_carousel"). El unico widget real de reseñas
  // con texto es este mismo cards_carousel (SELECTOR de mas abajo), tanto
  // en la ficha de producto como en el home. El codigo viejo apuntaba a un
  // selector que no existe -- no hacia nada, no rompia nada, pero era
  // codigo muerto.

  var debounceTimer = null;
  var userControlled = false;

  function realItems(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll('.jdgm-carousel-item:not([data-clone-type])')
    );
  }

  function applyToggle(container) {
    if (userControlled) return;

    var items = realItems(container);
    var widget = container.closest('.jdgm-cards-carousel');
    var anchor = widget || container;
    var existingBtn = anchor.nextElementSibling;
    var hasBtn = !!(existingBtn && existingBtn.classList && existingBtn.classList.contains('rg-reviews-more'));

    if (items.length <= VISIBLE_COUNT) {
      if (hasBtn) existingBtn.remove();
      return;
    }

    // Si el estado actual ya es el correcto, no tocar el DOM -- evita
    // reinsertar el boton en bucle cada vez que el observer reacciona a su
    // propia insercion anterior.
    var alreadyCorrect =
      hasBtn &&
      items.every(function (item, i) {
        var shouldHide = i >= VISIBLE_COUNT;
        return item.classList.contains('rg-reviews-hidden') === shouldHide;
      });
    if (alreadyCorrect) return;

    if (hasBtn) existingBtn.remove();

    items.forEach(function (item, i) {
      if (i >= VISIBLE_COUNT) {
        item.classList.add('rg-reviews-hidden');
      } else {
        item.classList.remove('rg-reviews-hidden');
      }
    });

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rg-reviews-more button button-secondary';
    btn.textContent = 'Mostrar más reseñas';

    var expanded = false;
    btn.addEventListener('click', function () {
      // Recien aca (con interaccion real del usuario) se bloquea que el
      // observer siga re-aplicando el estado automatico -- si se bloqueara
      // desde que se crea el boton, una reconstruccion tardia de Judge.me
      // dejaria el boton apuntando a tarjetas viejas ya desconectadas.
      userControlled = true;
      expanded = !expanded;
      items.forEach(function (item, i) {
        var shouldHide = !expanded && i >= VISIBLE_COUNT;
        item.classList.toggle('rg-reviews-hidden', shouldHide);
      });
      btn.textContent = expanded ? 'Mostrar menos' : 'Mostrar más reseñas';
      if (!expanded) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    anchor.insertAdjacentElement('afterend', btn);
  }

  function fixTitle() {
    var title = document.querySelector('.jdgm-cards-carousel .jdgm-title');
    if (title && !title.dataset.rgTranslated) {
      title.textContent = 'Lo que opinan nuestros clientes';
      title.dataset.rgTranslated = 'true';
    }
  }

  function run() {
    fixTitle();
    var container = document.querySelector(SELECTOR);
    if (container) applyToggle(container);
  }

  function scheduleRun() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(run, DEBOUNCE);
  }

  function start() {
    run();

    function onDomChange(mutations) {
      // Ignorar los cambios que genera el propio script (agregar/quitar
      // rg-reviews-hidden o el boton) para no entrar en loop.
      var relevant = (mutations || []).some(function (m) {
        if (m.target && m.target.classList && m.target.classList.contains('rg-reviews-hidden')) return false;
        if (m.target && m.target.className === 'rg-reviews-more') return false;
        return true;
      });
      if (relevant) scheduleRun();
    }

    // rg (2026-09-16): antes este script tenia su PROPIO MutationObserver
    // permanente sobre document.body -- uno de 4 en el tema, cada uno
    // disparandose ante CUALQUIER cambio del DOM de toda la pagina
    // (hallazgo de rendimiento de la auditoria). Se consolida en un unico
    // observer compartido con los snippets de envio gratis/carrito: el
    // primer script en cargar lo crea, el resto solo se suscribe.
    if (!window.__rgObservarCambiosDom) {
      window.__rgDomWatchers = [];
      window.__rgObservarCambiosDom = function (fn) { window.__rgDomWatchers.push(fn); };
      new MutationObserver(function (mutaciones) {
        window.__rgDomWatchers.forEach(function (fn) { fn(mutaciones); });
      }).observe(document.body, { childList: true, subtree: true });
    }
    window.__rgObservarCambiosDom(onDomChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
